<template>
  <v-card :class="$options.name">
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          v-model="form.name"
          :value="data.name"
          :rules="rules.name"
          label="Название роли"
        />

        <!--        <parent-role-select-->
        <!--          v-model="form.parent"-->
        <!--          :data="data.parent"-->
        <!--          :items-list="rolesList"-->
        <!--        />-->

        <permissions-select
          v-if="isEdit"
          v-model="form.permissions"
          :data="data.permissions"
          :items-list="permissionsList"
        />

        <regions-select
          v-if="isEdit"
          v-model="form.regions"
          :data="data.regions"
          :items-list="regionsList"
        />
      </v-form>
    </v-card-text>
    <v-card-actions class="ml-2 mr-2">
      <slot name="action-buttons" />
      <div class="flex-grow-1" />
      <v-btn
        v-permission="['role-create', 'role-edit']"
        color="primary lighten-1"
        text
        @click="onSubmit"
        v-text="buttonLabel"
      />
    </v-card-actions>
  </v-card>
</template>

<script>
import RegionsSelect from '@/components/page/regions/regions-select';
import PermissionsSelect from './RoleForm/PermissionsSelect.vue';
// import ParentRoleSelect from './RoleForm/ParentRoleSelect.vue';

const createDefaultForm = () => ({
  name: null,
  parent: null,
  regions: [],
  permissions: [],
});

export default {
  name: 'role-form',
  components: {
    // ParentRoleSelect,
    PermissionsSelect,
    RegionsSelect,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    isEdit: Boolean,
    data: {
      type: Object,
      default: createDefaultForm,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    permissionsList: {
      type: Array,
      default: () => ([]),
    },
    regionsList: {
      type: Array,
      default: () => ([]),
    },
    rolesList: {
      type: Array,
      default: () => ([]),
    },
  },
  data: () => ({
    form: createDefaultForm(),
    valid: true,
    rules: {
      name: [
        v => !!v || 'Название роли обязательно для заполнения',
      ],
    },
  }),
  computed: {
    formTitle() {
      return this.isEdit ? 'Редактирование роли' : 'Новая роль';
    },
    buttonLabel() {
      return this.isEdit ? 'Сохранить изменения' : 'Создать роль';
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler: 'updateData',
    },
    form: {
      deep: true,
      handler(value) {
        this.$emit('change', value);
      },
    },
  },
  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$emit('change', this.form);
        this.$emit('submit', this.form);
      }
    },

    updateData() {
      this.form = {
        ...this.form,
        ...this.data,
      };
    },
  },
};
</script>
